import type { Offer } from "@assets/types";
import { formatPercent, formatPrice } from "@assets/utils";
import { useMediaQuery } from "react-responsive";

export function SpendAndGetMechanic({
	item,
	HumanImage,
	isMobile,
}: {
	item: Offer | undefined;
	HumanImage: React.ReactNode;
	isMobile: boolean;
}) {
	return (
		<>
			<div className="popup_content_header">
				<div className={`small_text ${isMobile && "spend_and_get"}`}>
					{isMobile && "Ganhe agora:"}
				</div>
			</div>

			<div className="main_content">
				{isMobile && <div className="main_content_media">{HumanImage}</div>}

				<div className="main_content_text">
					<div className="small_header">
						{`Compre acima de ${formatPrice(item?.minAmount || 0)} e `}
						<span className="enlarged">GANHE</span>
					</div>

					<div className={`discount_size ${item?.mechanic}`}>
						{item?.discountAmount && `${formatPrice(item?.discountAmount || 0)} OFF`}
					</div>

					<div className={`subheader ${item?.mechanic}`}>
						em sua compra no{" "} <span className="enlarged">{window.parameters.glob_programName}</span>
					</div>
				</div>
			</div>
		</>
	);
}

export function SpendAndGetPercentMechanic({
	item,
	HumanImage,
	isMobile,
}: {
	item: Offer | undefined;
	HumanImage: React.ReactNode;
	isMobile: boolean;
}) {
	return (
		<>
			<div className="popup_content_header">
				<div className={`small_text ${isMobile && "spend_and_get"}`}>
					{isMobile && "Ganhe agora:"}
				</div>
			</div>

			<div className="main_content">
				{isMobile && <div className="main_content_media">{HumanImage}</div>}

				<div className="main_content_text">
					<div className="small_header">
						{`Compre acima de ${formatPrice(item?.minAmount || 0)} e `}
						<span className="enlarged">GANHE</span>
					</div>

					<div className={`discount_size ${item?.mechanic} percent`}>
						{item?.discountPercent && `${formatPercent(item?.discountPercent || 0)}%`}
					</div>

					<div className={`subheader ${item?.mechanic}`}>
						de desconto em sua compra no{" "} <span className="enlarged">{window.parameters.glob_programName}</span>
					</div>
				</div>
			</div>
		</>
	);
}

export function CashbackMoneyMechanic({
	item,
	HumanImage,
	isMobile,
}: {
	item: Offer | undefined;
	HumanImage: React.ReactNode;
	isMobile: boolean;
}) {
	return (
		<>
			<div className="popup_content_header">
				<div
					className={`small_text`}
				>
					Seu dinheiro
				</div>

				<div className={`big_text ${item?.mechanic}`}>
					DE VOLTA!
				</div>
			</div>

			<div className="main_content">
				{isMobile && <div className="main_content_media">{HumanImage}</div>}

				<div className="main_content_text">
					<div className="small_header">
						{`Compre acima de ${formatPrice(item?.minAmount || 0)} e `}
						<span className="enlarged">RECEBA</span>
					</div>

					<div className={`discount_size ${item?.mechanic}`}>
						{item?.discountPercent
							? `${formatPercent(item?.discountPercent || 0)}%`
							: item?.discountAmount
								? formatPrice(item?.discountAmount || 0)
								: ""}
					</div>

					<div className={`subheader ${item?.mechanic}`}>
						do seu dinheiro de volta para usar em sua próxima compra
						no <span className="enlarged">{window.parameters.glob_programName}</span>
					</div>
				</div>
			</div>
		</>
	);
}

export function CashbackPercentMechanic({
	item,
	HumanImage,
	isMobile,
}: {
	item: Offer | undefined;
	HumanImage: React.ReactNode;
	isMobile: boolean;
}) {
	return (
		<>
			<div className="popup_content_header">
				<div
					className={`small_text`}
				>
					Seu dinheiro
				</div>

				<div className={`big_text ${item?.mechanic}`}>
					DE VOLTA!
				</div>
			</div>

			<div className="main_content">
				{isMobile && <div className="main_content_media">{HumanImage}</div>}

				<div className="main_content_text">
					<div className="small_header">
						{`Compre acima de ${formatPrice(item?.minAmount || 0)} e `}
						<span className="enlarged">RECEBA</span>
					</div>

					<div className={`discount_size ${item?.mechanic}`}>
						{item?.discountPercent
							? `${formatPercent(item?.discountPercent || 0)}%`
							: item?.discountAmount
								? formatPrice(item?.discountAmount || 0)
								: ""}
					</div>

					<div className={`subheader ${item?.mechanic}`}>
						do seu dinheiro de volta para usar em sua próxima compra
						no <span className="enlarged">{window.parameters.glob_programName}</span>
					</div>
				</div>
			</div>
		</>
	);
}

export function MechanicContent({
	item,
	HumanImage,
}: {
	item: Offer | undefined;
	HumanImage: React.ReactNode;
}) {
	const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

	switch (item?.mechanic) {
		case "spend_and_get":
			return <SpendAndGetMechanic item={item} HumanImage={HumanImage} isMobile={isMobile} />
		case "spend_and_get_percent":
			return <SpendAndGetPercentMechanic item={item} HumanImage={HumanImage} isMobile={isMobile} />
		case "cashback_money":
			return <CashbackMoneyMechanic item={item} HumanImage={HumanImage} isMobile={isMobile} />
		case "cashback_percent":
			return <CashbackPercentMechanic item={item} HumanImage={HumanImage} isMobile={isMobile} />
		default:
			return null;
	}
}
